export const AUTOSOME_ORDER = Array.from({ length: 22 }, (_, index) => index + 1);

export const CHROMOSOME_SIZES_HG19 = {
    1: 249250621,
    2: 243199373,
    3: 198022430,
    4: 191154276,
    5: 180915260,
    6: 171115067,
    7: 159138663,
    8: 146364022,
    9: 141213431,
    10: 135534747,
    11: 135006516,
    12: 133851895,
    13: 115169878,
    14: 107349540,
    15: 102531392,
    16: 90354753,
    17: 81195210,
    18: 78077248,
    19: 59128983,
    20: 63025520,
    21: 48129895,
    22: 51304566,
};

export const ACROCENTRIC_CHROMOSOMES = new Set([13, 14, 15, 21, 22]);

// Approximate hg19 p-arm lengths in base pairs used to indicate not-sampled short arms.
export const ACROCENTRIC_SHORT_ARM_BP = {
    13: 17996158,
    14: 17653793,
    15: 19000000,
    21: 13200000,
    22: 14700000,
};

export const MAX_AUTOSOME_BP_HG19 = Math.max(...Object.values(CHROMOSOME_SIZES_HG19));
